<template>
  <!--  This loads the elements date picker. -->
  <!-- question: would the initial query work with a custom element that is a plain text field?  -->
  <div>
    <template v-if="showOnly">
      {{ value }}
    </template>
    <template v-else>
      <el-date-picker
        :id="id"
        v-model="localValue"
        prefix-icon=""
        type="date"
        format="dd-MM-yyyy"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        :placeholder="placeholder"
        @change="updateValue"
      />
    </template>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui'
import locale from 'element-ui/lib/locale'

const lang = require(`element-ui/lib/locale/lang/${Lang.locale}`).default
locale.use(lang)

export default {
  name: 'QueryDatePicker',

  components: {
    DatePicker,
  },
  props: {
    value: String,
    showOnly: {
      type: Boolean,
      default: false,
    },
    id: {
      required: false,
      type: String,
      default: 'date',
    },
    placeholder: {
      required: false,
      type: String,
      default: null,
    },
    default () {
      return new Date()
    },
  },

  data () {
    return {
      localValue: '',
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    }
  },

  watch: {
    value: function (value) {
      this.localValue = value
    },
  },

  mounted () {
    this.localValue = this.value
  },

  methods: {
    updateValue () {
      this.$emit('input', this.localValue)
    },
  },
}
</script>
